import createSignalEventsService from "./factory";

export default createSignalEventsService();
